import Blue from "~/core";
import Swiper, { Pagination, A11y, Autoplay } from "swiper";
import "swiper/css";

new Blue({
	name: 'Testimonial Carousel',
	selector: ".testimonial--carousel",
	setup(testimonialCarousel) {
		const container = testimonialCarousel.querySelector(".testimonial__container");
		const wrapper = container.querySelector(".testimonial__inner");
		const slides = [...container.querySelectorAll(".testimonial__slide")];
		const pagination = testimonialCarousel.querySelector(".testimonial__pagination");
		const blueCompositionWrapper = testimonialCarousel.closest("blue-composition");

		const addBGImage = activeSlide => {
			if (activeSlide.matches(".testimonial__slide--background")) {
				let src = activeSlide.querySelector(".testimonial__media img").getAttribute("src");
				if (!!blueCompositionWrapper) {
					blueCompositionWrapper.style.backgroundImage = `url(${src})`;
					blueCompositionWrapper.classList.add("testimonial--bg-temp")
				} else  {
					testimonialCarousel.style.backgroundImage = `url(${src})`;
					testimonialCarousel.classList.add("testimonial--bg-temp")
				}
			} else {
				if (!!blueCompositionWrapper) {
					blueCompositionWrapper.style.backgroundImage = "";
					blueCompositionWrapper.classList.remove("testimonial--bg-temp")
				} else {
					testimonialCarousel.style.backgroundImage = "";
					testimonialCarousel.classList.remove("testimonial--bg-temp")
				}
			}
		}

		if (slides.length > 1) {
			container.classList.add("swiper");
			wrapper.classList.add("swiper-wrapper");
			slides.forEach(s => s.classList.add("swiper-slide"));
			const scrollTime = !isNaN(parseFloat(testimonialCarousel.getAttribute("data-scroll-time"))) ? parseFloat(testimonialCarousel.getAttribute("data-scroll-time")) * 1000 : 11000;

			// fix for autoHeight issues
			const resizeWrapper = activeSlide => {
				let slideBodyHeight = activeSlide.querySelector(".testimonial__body").offsetHeight;
				let slideStarsHeight = activeSlide.querySelector(".testimonial__stars")?.offsetHeight || 0;
				const start = wrapper.offsetHeight;
				wrapper.style.height = `${slideBodyHeight + slideStarsHeight}px`;
				const end = wrapper.offsetHeight;
				wrapper.animate([
					{height: `${start}px`},
					{height: `${end}px`}
				], {
					duration: 180,
					easing: 'ease'
				});
			}

			const movePagination = activeSlide => {
				if (window.innerWidth >= 769) {
					let content = activeSlide.querySelector(".testimonial__content");
					let slideLeft = activeSlide.getBoundingClientRect().left;
					let contentLeft = content.getBoundingClientRect().left;
					pagination.style.left = contentLeft - slideLeft + "px";
				} else {
					pagination.style.left = "";
				}
			}

			const makeSlideAdjustments = () => {
				let activeSlide = container.querySelector(`.swiper-slide-active`);
				resizeWrapper(activeSlide);
				addBGImage(activeSlide);
				// movePagination(activeSlide); // Per client, pagination dots now to be centered on all slides regardless of layout, as of 1.17.23
			}

			let config = {
				modules: [A11y, Autoplay],
				autoplay: {
					delay: scrollTime
				},
				loop: true,
				a11y: true,
				on: {
					afterInit: function() {makeSlideAdjustments()},
					slideNextTransitionStart: function() {makeSlideAdjustments()},
					slidePrevTransitionStart: function() {makeSlideAdjustments()},
				}
			}
	
			if (!!pagination) {
				pagination.classList.add("swiper-pagination");
				let modArray = config.modules;
				modArray.push(Pagination)
				config['modules'] = modArray;
				config['pagination'] = {
					el: pagination,
					clickable: true
				};
			}

			const swiper = new Swiper(container, config);
		} else if (slides.length > 0) {
			addBGImage(slides[0]);
		}

	}
});